module.exports = __webpack_public_path__ + "img/icon.ee7eb480.png";